/**
 *
 * CornerColor
 *
 */
import * as React from 'react';
import Img from 'components/Img';

import styled from 'styled-components/macro';
// eslint-disable-next-line no-restricted-imports
import { css } from 'styled-components';

interface Props {
  imageSrc: string;
  title: string;
  selected?: boolean;
  onClick?: any;
  onHover?: any;
  square?: boolean;
  disabled?: boolean;
  tooltip?: string | null;
}

function SelectorRibbonOption({
  disabled,
  onClick,
  selected,
  onHover,
  square,
  imageSrc,
  title,
  tooltip,
}: Props) {
  return (
    <div data-tip={tooltip} data-for="composition">
      <StyledSelectorButton
        selected={selected}
        onClick={onClick}
        onMouseOver={onHover}
        disabled={disabled}
      >
        <StyledSelectorImage square={square}>
          <Img src={imageSrc} alt={title} className="w-full h-full" />
        </StyledSelectorImage>
        <StyledSelectorTitle
          selected={selected}
          className="title hover:font-bold"
        >
          <div className="whitespace-pre-line leading-none">{title}</div>
        </StyledSelectorTitle>
      </StyledSelectorButton>
    </div>
  );
}

export default SelectorRibbonOption;

const StyledSelectorButton = styled.button<{
  selected?: boolean;
  disabled?: boolean;
}>`
  display: flex;
  flex-direction: column;
  margin: 0.25rem 0rem;
  padding: 0.25rem 1rem;
  box-shadow: none !important;
  align-items: center;
  @media (min-width: 380px) {
    padding: 0.25rem 1.75rem;
  }
  @media (min-width: 1024px) {
    margin: 0;
    padding: 0.25rem 0.45rem;
  }
  ${p =>
    !p.selected &&
    !p.disabled &&
    css`
      &:hover {
        background-color: ${p => p.theme.hover};

        & .title {
          font-weight: 500;
          color: ${p => p.theme.gray700};
        }
      }
    `}
  ${p =>
    p.selected &&
    css`
      background-color: ${p => p.theme.main};
      font-weight: 500;
      cursor: default;
    `}
  
  ${p =>
    p.disabled &&
    css`
      cursor: not-allowed;
    `}
`;

const StyledSelectorImage = styled.div<{ square?: boolean }>`
  // w-10 h-10 mt-1

  width: 3.2rem;
  height: 3rem;
  margin-top: 0.25rem;
  @media (min-width: 1024px) {
    width: ${p => (p.square ? '2.5rem' : '3rem')};
    height: 2.5rem;
  }
`;

const StyledSelectorTitle = styled.div<{ selected?: boolean }>`
  font-size: 0.75rem;
  align-self: center;
  color: ${p => p.theme.main};
  ${p =>
    p.selected &&
    css`
      color: ${p => p.theme.white};
      font-weight: 600;
    `}
`;
